import { render } from "./LineUp.vue?vue&type=template&id=2df4cd26"
import script from "./LineUp.vue?vue&type=script&lang=js"
export * from "./LineUp.vue?vue&type=script&lang=js"
script.render = render

export default script